import React, { useEffect, useState } from "react";
import { render } from 'react-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { store } from './redux/store';
import { ProviderContactCards } from '../../../../../../prototype/src/components/ProviderContactCards';
import { Pagination } from '../../../../../../prototype/src/components/Pagination';
import { getProviderItemsData } from './redux/slices/providerItemsSlice';
import { getSettings } from "../../../../../scripts/util/getSettings";
import shouldShowAcceptingPatients from '../../../../../../prototype/src/shared/shouldShowAcceptingPatients';

const location = getSettings(['vmc', 'location']);
const id = getSettings(['vmc', 'location', 'id']);
const labels = getSettings(['vmc', 'location', 'labels']);
const featuredAffiliations = getSettings(['vmc', 'location', 'featuredAffiliations']);
const placeHolderImagePath = getSettings(['vmc', 'location', 'placeHolderImagePath']);

const Component = () => {

  const [page, setPage] = useState(1);
  const providers = useSelector((state) => state.providerItems);
  const dispatch = useDispatch();

  useEffect(() => {
    if (location && location.addressGuids) {
      dispatch(getProviderItemsData(location.addressGuids, (page - 1) * 12, 12));
    }
  }, [page]);

  useEffect(() => {
    console.log(providers.data.total);
    if (providers.data.total > 0) {
      if (window.vmc && window.vmc.jumpLinksInit) {
        window.vmc.jumpLinksInit();
      }
    }
  }, [providers.data.total]);

  const prevOnClick = () => {
    setPage(page - 1);
  };

  const nextOnClick = () => {
    setPage(page + 1);
  };

  const pageOnClick = value => {
    setPage(value);
  };

  const getUI = () => {
    return (
      <div className="root" id={id}>
      <main>
        {!providers.isFetching && providers.data.total > 0 && <div className="text_block" style={{margin: '15px auto 40px'}}>
          <h2>{labels.title}</h2>
          <div dangerouslySetInnerHTML={{__html: labels.description}}></div>
        </div>}
        {!providers.isFetching && providers.data.total > 0 && providers.data.totalPages > 0 &&
          <Pagination
            results={12}
            currentPage={page}
            total={providers.data.total}
            totalPages={providers.data.totalPages}
            prevClick={prevOnClick}
            nextClick={nextOnClick}
            pageClick={pageOnClick} />}
        <div className="provider_contact_card_links">
          {!providers.isFetching && providers.data.success && providers.data.contactCardList.map((item, i) => {
            let providerAffiliation;
            if (item.affiliation && item.affiliation.length > 0) {
              if (featuredAffiliations.filter(x => x.value === item.affiliation[0].id).length > 0) {
                providerAffiliation = item.affiliation[0].name;
              }
            }
            let showAcceptPatients = shouldShowAcceptingPatients(item);
            console.log(`Here ${window.myChartProviderConfig && window.myChartProviderConfig.openSchedulingSearchResultsEnabled}`);
            
            return (
              <ProviderContactCards
                key={i}
                name={item.name}
                title={item.title}
                titles={item.titles}
                specialties={item.specialities.map(x => x.name)}
                acceptPatients={item.acceptPatients}
                acceptPatientsOriginal={item.acceptPatientsOriginal}
                acceptPatientsOriginalBioDisplayText={item.acceptPatientsOriginalBioDisplayText}
                acceptPatientsOriginalSearchDisplayText={item.acceptPatientsOriginalSearchDisplayText}
                acceptPatientsOriginalImageURL={item.acceptPatientsOriginalImageURL}
                showAcceptPatients={showAcceptPatients}
                affiliation={providerAffiliation}
                imageUrl={item.imageUrl}
                imageErrorUrl={placeHolderImagePath}
                bioPageUrl={item.bioPageUrl}
                telehealthOptionsAvailable={item.telehealthOptionsAvailable}
                myChartProviderID={item.myChartProviderID}
                myChartDepartmentID={item.myChartDepartmentID}
                myChartVisitTypeID={item.myChartVisitTypeID}
                myChartSchedulingSearchResultsEnabled={!!window.myChartProviderConfig && window.myChartProviderConfig.openSchedulingSearchResultsEnabled}
              />
            );
          })}
        </div>
        {providers.isFetching && <div className="spinner"><img src="/assets/images/loading.gif" alt="" /></div>}
        {!providers.data.isFetching && providers.data.total > 0 && providers.data.totalPages > 0 &&
          <Pagination
            results={12}
            currentPage={page}
            total={providers.data.total}
            totalPages={providers.data.totalPages}
            prevClick={prevOnClick}
            nextClick={nextOnClick}
            pageClick={pageOnClick} />}
      </main>
    </div>
    );
  };
  if (!providers.data.isFetching && providers.data.total > 0) {
    return getUI();
  }
  return null;
};

render(
  <Provider store={store}>
    <Component />
  </Provider>,
  document.getElementById('providersListRoot')
);